
import Vue, { PropType } from 'vue';
import { mapState } from 'pinia';
import Home16 from '@carbon/icons-vue/es/home/16';
import Image16 from '@carbon/icons-vue/es/image/16';
import Help16 from '@carbon/icons-vue/es/help/16';
import TextCreation16 from '@carbon/icons-vue/es/text--creation/16';
import IconTextButton from '../Buttons/IconTextButton.vue';
import {
  HOME_PANEL,
  IMAGE_PANEL,
  TEXT_PANEL,
  LANYARDS_PANEL,
} from '../../constants';
import { useStore as useProductStore } from '@/stores/v2/product';

export default Vue.extend({
  name: 'ActionsToolbar',

  components: { IconTextButton },

  props: {
    activePanel: {
      type: String,
      required: false,
      default: HOME_PANEL,
    },
  },

  data() {
    return {
      Home16: Home16,
      Image16: Image16,
      TextCreation16: TextCreation16,
      Help16: Help16,
      HOME_PANEL: HOME_PANEL,
      IMAGE_PANEL: IMAGE_PANEL,
      TEXT_PANEL: TEXT_PANEL,
      LANYARDS_PANEL: LANYARDS_PANEL,
    };
  },
  computed: {
    ...mapState(useProductStore, ['activePosition']),
  },
});
